import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/core';
export var HeadingStatus;

(function (HeadingStatus) {
  HeadingStatus["New"] = "New";
  HeadingStatus["Update"] = "Update";
  HeadingStatus["Deactivate"] = "Deactivate";
})(HeadingStatus || (HeadingStatus = {}));

export var NoneValue = 'none';
export var Heading = /*#__PURE__*/function (_Entity) {
  _inherits(Heading, _Entity);

  var _super = _createSuper(Heading);

  function Heading() {
    _classCallCheck(this, Heading);

    return _super.apply(this, arguments);
  }

  _createClass(Heading, [{
    key: "title",
    get: function get() {
      return this.props.title;
    }
  }, {
    key: "description",
    get: function get() {
      return this.props.description;
    }
  }, {
    key: "nextQuestionId",
    get: function get() {
      var _this$props$nextQuest;

      return (_this$props$nextQuest = this.props.nextQuestionId) !== null && _this$props$nextQuest !== void 0 ? _this$props$nextQuest : NoneValue;
    }
  }, {
    key: "previousHeadingId",
    get: function get() {
      var _this$props$previousH;

      return (_this$props$previousH = this.props.previousHeadingId) !== null && _this$props$previousH !== void 0 ? _this$props$previousH : NoneValue;
    }
  }, {
    key: "nextHeadingId",
    get: function get() {
      var _this$props$nextHeadi;

      return (_this$props$nextHeadi = this.props.nextHeadingId) !== null && _this$props$nextHeadi !== void 0 ? _this$props$nextHeadi : NoneValue;
    }
  }, {
    key: "previousQuestionId",
    get: function get() {
      var _this$props$previousQ;

      return (_this$props$previousQ = this.props.previousQuestionId) !== null && _this$props$previousQ !== void 0 ? _this$props$previousQ : NoneValue;
    }
  }, {
    key: "status",
    get: function get() {
      var _this$props$status;

      return (_this$props$status = this.props.status) !== null && _this$props$status !== void 0 ? _this$props$status : HeadingStatus.New;
    }
  }, {
    key: "type",
    get: function get() {
      var _this$props$type;

      return (_this$props$type = this.props.type) !== null && _this$props$type !== void 0 ? _this$props$type : 'heading';
    }
  }, {
    key: "sectionId",
    get: function get() {
      var _this$props$sectionId;

      return (_this$props$sectionId = this.props.sectionId) !== null && _this$props$sectionId !== void 0 ? _this$props$sectionId : '';
    }
  }, {
    key: "formId",
    get: function get() {
      var _this$props$formId;

      return (_this$props$formId = this.props.formId) !== null && _this$props$formId !== void 0 ? _this$props$formId : '';
    }
  }, {
    key: "aiChangeType",
    get: function get() {
      return this.props.aiChangeType;
    }
  }, {
    key: "updateTitle",
    value: function updateTitle(title) {
      this.props.title = title;
      return Result.ok();
    }
  }, {
    key: "updateDescription",
    value: function updateDescription(description) {
      this.props.description = description;
      return Result.ok();
    }
  }, {
    key: "updateStatus",
    value: function updateStatus(status) {
      this.props.status = status;
      return Result.ok();
    }
  }, {
    key: "updatePreviousHeadingId",
    value: function updatePreviousHeadingId(previousHeadingId) {
      this.props.previousHeadingId = previousHeadingId;
      return Result.ok();
    }
  }, {
    key: "updateNextHeadingId",
    value: function updateNextHeadingId(nextHeadingId) {
      this.props.nextHeadingId = nextHeadingId;
      return Result.ok();
    }
  }, {
    key: "updatePreviousQuestionId",
    value: function updatePreviousQuestionId(previousQuestionId) {
      this.props.previousQuestionId = previousQuestionId;
      return Result.ok();
    }
  }, {
    key: "updateNextQuestionId",
    value: function updateNextQuestionId(nextQuestionId) {
      this.props.nextQuestionId = nextQuestionId;
      return Result.ok();
    }
  }, {
    key: "updateSectionId",
    value: function updateSectionId(sectionId) {
      this.props.sectionId = sectionId;
      return Result.ok();
    }
  }, {
    key: "deActivate",
    value: function deActivate() {
      this.props.status = HeadingStatus.Deactivate;
      return Result.ok();
    }
  }, {
    key: "clone",
    value: function clone() {
      var clonedProps = {
        title: this.title,
        description: this.description,
        previousQuestionId: this.previousQuestionId,
        nextQuestionId: this.nextQuestionId,
        previousHeadingId: this.previousHeadingId,
        nextHeadingId: this.nextHeadingId,
        status: this.status,
        type: this.type,
        sectionId: this.sectionId,
        formId: this.formId
      };
      return Heading.create(clonedProps, this.id.toString()).getValue();
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread({}, this.props);
    }
  }], [{
    key: "create",
    value: function create(props, id) {
      var _props$previousHeadin, _props$nextHeadingId, _props$nextQuestionId, _props$previousQuesti, _props$status, _props$type;

      var guardCollections = [{
        argument: props.title,
        argumentName: 'Heading Title'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      var defaultProps = _objectSpread(_objectSpread({}, props), {}, {
        previousHeadingId: (_props$previousHeadin = props.previousHeadingId) !== null && _props$previousHeadin !== void 0 ? _props$previousHeadin : NoneValue,
        nextHeadingId: (_props$nextHeadingId = props.nextHeadingId) !== null && _props$nextHeadingId !== void 0 ? _props$nextHeadingId : NoneValue,
        nextQuestionId: (_props$nextQuestionId = props.nextQuestionId) !== null && _props$nextQuestionId !== void 0 ? _props$nextQuestionId : NoneValue,
        previousQuestionId: (_props$previousQuesti = props.previousQuestionId) !== null && _props$previousQuesti !== void 0 ? _props$previousQuesti : NoneValue,
        status: (_props$status = props.status) !== null && _props$status !== void 0 ? _props$status : HeadingStatus.New,
        type: (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'heading'
      });

      return Result.ok(new Heading(defaultProps, new UniqueEntityID(id)));
    }
  }, {
    key: "isTopHeading",
    value: function isTopHeading(heading) {
      return heading.previousHeadingId === NoneValue;
    }
  }, {
    key: "isBottomHeading",
    value: function isBottomHeading(heading) {
      return heading.nextHeadingId === NoneValue;
    }
  }]);

  return Heading;
}(Entity);